import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { CentroCusto } from '../interface/centro-custo';

@Injectable({
  providedIn: 'root'
})
export class CentroCustoLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrcontabilidade/centrocusto`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<CentroCusto> {
    return this.httpClient.get<CentroCusto>(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CCTTCUSTO' , optional: true, gridColumns: 6, label: 'Codigo'},
      {property: 'CCTTDESC01', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CCTTCUSTO' , label: 'Código'},
      {property: 'CCTTDESC01', label: 'Descrição'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CCTTCUSTO} - ${value.CCTTDESC01}`;
  }
}
